import {
  CreateFacilityBillableRateDto,
  CreateFacilityScheduledBillableRateDto,
} from './create-facility-billable-rate.dto';

export interface UpdateFacilityBillableRateDto
  extends CreateFacilityBillableRateDto {
  scheduledRates: UpdateFacilityScheduledBillableRateDto[];
}

export interface UpdateFacilityScheduledBillableRateDto
  extends CreateFacilityScheduledBillableRateDto {
  id?: string; // Include ID to update existing scheduled rate, omit to create new
}
